import React, { Component } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { GlobalStyleProps } from '../types/types'
import { CssBaseline } from "@material-ui/core";

import {renderRoutes} from "react-router-config"

const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    background: ${props => props.theme.body.background};
  }
`;

const Root = styled.div`
  max-width: 520px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
`;

class Auth extends Component{
    render(){
        return (
            <Root>
                <CssBaseline />
                <GlobalStyle />
                {this.props.children}

            </Root>
        );
    }
}
const AuthLayout: React.FC = props => {
    //@ts-ignore
    const route = props.route || {};
    return <Auth>{renderRoutes(route.routes)}</Auth>
};


export default AuthLayout;
